<b
  class="text-primary"
  style="cursor: pointer"
  containerClass="dark"
  placement="bottom"
  [outsideClick]="true"
  [popover]="countryLevelFilingRefNumInfo"
  (onShown)="getVendorCountryFilingReferenceNumbers()">
  Country Level
</b>

<ng-template #countryLevelFilingRefNumInfo>
  <div style="width: 220px;">
    <div class="text-center p-5" *ngIf="!vendorCountryRefNumbers?.length">
      <i class="fa fa-spinner fa-spin"></i>
    </div>
    <div class="p-2" *ngIf="vendorCountryRefNumbers?.length">
      <b class="text-primary">Country Level Filing Reference Numbers</b>
      <div
        class="d-flex align-items-center pt-2"
        *ngFor="let vendorRefNum of vendorCountryRefNumbers; let last = last"
        [ngClass]="{ 'border-bottom pb-2': !last }">
        <div class="d-flex align-items-center px-1 w-50">
          <div class="mr-2">
            <img
              alt="flag"
              src="/assets/flags/4x3/{{vendorRefNum.country.id | country: 'flag'}}"
              style="height: 1.2rem;"/>
          </div>
          <span class="text-truncate">{{vendorRefNum.country.id | country}}</span>
        </div>
        <div class="w-50 text-right text-truncate" [title]="vendorRefNum.referenceNumber">
          {{vendorRefNum.referenceNumber}}
        </div>
      </div>
    </div>
  </div>
</ng-template>
